<template>
  <v-app id="inspire">
    <!-- <v-navigation-drawer v-model="drawer" :clipped="$vuetify.breakpoint.lgAndUp" app> -->
    <v-navigation-drawer
      v-model="drawer"
      :clipped="$vuetify.breakpoint.smAndUp"
      :mobile-break-point="768"
      app
    >
      <v-list dense expand class="z-app-list">
        <v-row>
          <v-list-item class="pl-6">
            <v-list-item-avatar class="zh-avatar">
              <v-img :src="user.img"></v-img>
            </v-list-item-avatar>
            <v-list-item-content class="pl-1">
              <v-list-item-title>{{ this.$store.state.user.name }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-row>
        <v-divider></v-divider>
        <template v-for="item in this.$store.state.menus">
          <!-- v-list-group 模板：套用有 children 屬性的資料 -->
          <v-list-group
            v-if="item.children"
            :key="item.text"
            v-model="item.model"
            :prepend-icon="item.model ? 'mdi-chevron-up' : 'mdi-chevron-down'"
            append-icon
          >
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title>{{ item.text }}</v-list-item-title>
              </v-list-item-content>
            </template>
            <v-list-item
              v-for="(child, i) in item.children"
              :key="i"
              link
              :to="child.link"
            >
              <v-list-item-action v-if="child.icon">
                <v-icon>{{ child.icon }}</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>{{ child.text }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
          <!-- v-list-item 模板：套用未被上述條件捕獲資料 -->
          <v-list-item v-else :key="item.text" link :to="item.link">
            <v-list-item-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>{{ item.text }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
        <v-divider></v-divider>

        <v-list-item link :to="'/'">
          <v-list-item-action>
            <v-icon>mdi-home</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>回首頁</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item v-if="($store.state.isLogin = true)" @click="logout()">
          <v-list-item-action>
            <v-icon>mdi-logout</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>登出</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <!-- app-bar-->
    <v-app-bar :clipped-left="$vuetify.breakpoint.smAndUp" app color="primary" dark>
      <!-- drawer 收闔 icon -->
      <v-app-bar-nav-icon @click.stop="drawer = !drawer" />
      <!-- drawer 收闔 icon 旁邊的 title 文字 -->
      <v-toolbar-title style="width: 300px" class="ml-0 pl-4">
        <span class="hidden-sm-and-down">問卷調查系統</span>
      </v-toolbar-title>
      <!-- 中間的分隔，讓旁邊的元素往靠左右兩邊靠攏，以上靠左，以下靠右 -->
      <v-spacer />
      <!-- 如果有元素要放在最右邊就放這 -->
      <v-btn icon large>
        <v-avatar size="32px" item class="zh-avatar">
          <v-img :src="$store.state.logo" alt="Vuetify" />
        </v-avatar>
      </v-btn>
    </v-app-bar>
    <!-- 用 v-content 包起來，渲染時就會先排除 appbar、drawer 佔去的版面，才不會被蓋住 -->
    <v-content>
      <router-view />
    </v-content>
  </v-app>
</template>

<script>
export default {
  mounted() {
    // 取得 menu tree
    this.$store.dispatch('getMenuTree')
    // 導到 router-view 首頁
    this.$router.push({ name: 'A00000' })
  },
  props: {
    source: String
  },
  data: () => ({
    drawer: null
  }),
  methods: {
    logout() {
      // 將狀態設定為登出
      this.$store.state.user.isLogin = false

      // 以下 ajax 解除 cookie 登入資訊
      let url = this.$store.state.api + '/Logout'
      // let url = '/admin/api/Logout'

      // let data = Object.assign({ queryType: '123' })
      // this.axios.post(url, this.qs.stringify(data)).then(res => {
      this.axios.get(url).then(res => {
        window.console.log(res.data)
        if (res.data.resultCode == '10') {
          this.$router.push({ name: 'Login' })
        } else {
          alert(res.data.error)
        }
      })
    }
  },
  computed: {
    user() {
      return {
        name: this.$store.state.user.name,
        img: this.$store.state.user.img
      }
    }
  }
}
</script>

<style lang="scss">
// 加大 drawer menu list 裡面的間距
.z-app-list .v-list-item {
  padding-top: 4px !important;
  padding-bottom: 4px !important;
}
@keyframes onhover {
  0% {
  }
  50% {
    transform: rotateY(360deg);
  }
  100% {
    transform: rotateY(0deg);
  }
}
.zh-avatar:hover {
  animation-name: onhover;
  animation-duration: 0.6s;
}
</style>
